import { useEffect, useState } from "react";
import {
  Button,
  CardHeader,
  DataGrid,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Loading,
  List,
  ListItemButton,
  ListItemText,
  TextField,
  Chip,
  Box,
  Typography,
  IconButton,
} from "../../../../../components";
import { NfSaidaService } from "../../../../../services";
import { formatDate, formatPrice, responseErros } from "../../../../../utils";
import { format } from "date-fns";
import { obterIconeStatus } from "../../../list-nf-saida/list-nf-saida";

const filtrosIniciasPaginacao = {
  page: 1,
  limit: 10,
  orderBy: "updatedAt",
  order: "desc",
};

const HistorioClienteDialog = ({
  open,
  setOpen,
  clienteId,
  nfsSaida,
  setNfsSaida,
  totalItems,
  setTotalItems,
}) => {
  const nfSaidaService = new NfSaidaService();
  const [loading, setLoading] = useState(false);
  const [itens, setItens] = useState([]);
  const [nfsaidaselecionada, setNfSaidaSelecionada] = useState(null);
  const [filtros, setFiltros] = useState({
    ...filtrosIniciasPaginacao,
  });
  const [query, setQuery] = useState("");

  const colunasItens = [
    {
      field: "codigo",
      headerName: "Cod.",
      flex: 100,
    },
    {
      field: "descricao",
      headerName: "Produto",
      flex: 400,
    },
    {
      field: "quantidade",
      headerName: "Quantidade",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "valor",
      headerName: "Valor R$",
      headerAlign: "right",
      align: "right",
      flex: 200,
      valueGetter: (params) => formatPrice(parseFloat(params.value), false),
    },
    {
      field: "subtotal",
      headerName: "Subtotal R$",
      flex: 300,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) =>
        params.value ? formatPrice(parseFloat(params.value), false) : "",
    },
  ];

  useEffect(() => {
    if (open && clienteId) {
      const filtrosTemp = {
        ...filtros,
        clienteId,
      };
      buscarNfSaida(filtrosTemp);
    }
  }, [open, clienteId, filtros]);

  const buscarNfSaida = async (filtros) => {
    setLoading(true);
    const result = await nfSaidaService.getAll(filtros);
    if (!result.isAxiosError) {
      setNfsSaida(result.data.rows);
      setTotalItems(result.data.count);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const handlePageChange = (newPage) => {
    setFiltros((prevFilters) => ({
      ...prevFilters,
      page: newPage,
    }));
    setNfSaidaSelecionada(null);
    setItens([]);
  };

  const handleBusca = (searchValue) => {
    setQuery(searchValue);
    setFiltros(() => ({
      ...filtrosIniciasPaginacao,
      numeroDocumento: searchValue,
    }));
    setNfSaidaSelecionada(null);
    setItens([]);
  };

  const handleNfSaidaClick = (nfSaida) => {
    setNfSaidaSelecionada(nfSaida);
    setItens(nfSaida.nfSaidaItens);
  };

  const handleClose = () => {
    setOpen(false);
    setItens([]);
    setNfSaidaSelecionada(null);
    setFiltros({ ...filtrosIniciasPaginacao });
    setQuery("");
  };

  const totalPaginas = Math.ceil(totalItems / filtros.limit / 2);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xl"
      PaperProps={{
        sx: {
          minHeight: "75vh",
          maxHeight: "90vh",
        },
      }}
    >
      <div className="px-3">
        <CardHeader
          title="Histórico de Cliente"
          action={
            <IconButton
              color="inherit"
              onClick={handleClose}
              sx={{
                backgroundColor: "#EDEEF0",
                "&:hover": { backgroundColor: "#B6BABC" },
              }}
            >
              <i
                className="ph-bold ph-x"
                style={{ fontSize: "clamp(17px, 4vw, 20px)" }}
              ></i>
            </IconButton>
          }
        />
      </div>

      <DialogContent sx={{ p: 1 }}>
        <Grid container sx={{ minHeight: "60vh" }}>
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              borderRight: "1px solid",
              borderColor: "divider",
              p: 0,
            }}
          >
            <Box sx={{ px: 2 }}>
              <Typography
                variant="subtitle2"
                gutterBottom
                sx={{ mt: 1, mb: 3 }}
              >
                Lista de Documentos
              </Typography>

              <div className="d-flex flex-row justify-content-start align-items-center mb-3">
                <TextField
                  label="Pesquisar por Nº Documento"
                  variant="outlined"
                  size="small"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      handleBusca(query);
                    }
                  }}
                  sx={{ mr: 1, flex: 1 }}
                />
                <Button variant="contained" onClick={() => handleBusca(query)}>
                  Buscar
                </Button>
              </div>
              {nfsSaida.length > 0 ? (
                <List sx={{ maxHeight: 400, overflowY: "auto", pr: 1 }}>
                  {nfsSaida.map((nfSaida) => (
                    <ListItemButton
                      key={nfSaida.id}
                      sx={{
                        borderRadius: "8px",
                        mb: 2,
                        py: 1,
                        px: 2,
                        border:
                          nfsaidaselecionada?.id === nfSaida.id
                            ? "2px solid #2196f3"
                            : "1px solid transparent",
                        backgroundColor:
                          nfsaidaselecionada?.id === nfSaida.id
                            ? "#e3f2fd"
                            : "white",
                        boxShadow:
                          nfsaidaselecionada?.id === nfSaida.id
                            ? "0 4px 12px rgba(25, 118, 210, 0.15)"
                            : "0 2px 4px rgba(0, 0, 0, 0.05)",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        "&:hover": {
                          backgroundColor:
                            nfsaidaselecionada?.id === nfSaida.id
                              ? "#e3f2fd"
                              : "#f5f5f5",
                          transform: "translateY(-1px)",
                          boxShadow: "0 6px 16px rgba(0, 0, 0, 0.1)",
                        },
                      }}
                      disableRipple
                      selected={nfsaidaselecionada?.id === nfSaida.id}
                      onClick={() => handleNfSaidaClick(nfSaida)}
                    >
                      <ListItemText
                        primary={`Documento: ${nfSaida.serieDocumento}/${nfSaida.numeroDocumento}`}
                        secondary={`Data de Criação: ${format(
                          formatDate.received(nfSaida.createdAt),
                          "dd/MM/yyyy"
                        )}`}
                      />
                      {obterIconeStatus(nfSaida?.status)}
                    </ListItemButton>
                  ))}
                </List>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "200px",
                    p: 3,
                  }}
                >
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: "center", fontWeight: 500 }}
                  >
                    Nenhum documento encontrado.
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              py: 1,
              px: 2,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "white",
            }}
          >
            {nfsaidaselecionada ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      color: "text.secondary",
                    }}
                  >
                    {`Itens do Documento - ${nfsaidaselecionada.serieDocumento}/${nfsaidaselecionada.numeroDocumento}`}
                  </Typography>
                </Box>

                <DataGrid
                  rows={itens}
                  columns={colunasItens}
                  loading={loading}
                  disableSelectionOnClick
                  noFilter
                  disableAcoes
                  hideFooter
                />
              </Box>
            ) : (
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 4,
                }}
              >
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    backgroundColor: "#f0f0f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 3,
                  }}
                >
                  <i
                    className="ph ph-arrow-left"
                    style={{ fontSize: 36, color: "#bdbdbd" }}
                  />
                </Box>
                <Typography
                  variant="h6"
                  color="text.secondary"
                  sx={{ mb: 1, fontWeight: 500, textAlign: "center" }}
                >
                  Selecione um documento
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "center", maxWidth: 280 }}
                >
                  Clique em um documento na lista ao lado para visualizar seus
                  itens detalhados.
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className="d-flex justify-content-between m-3">
        <Box
          className="d-flex justify-content-center align-items-center"
          sx={{
            mx: "80px",
          }}
        >
          <Button
            onClick={() => handlePageChange(filtros.page - 1)}
            disabled={filtros.page === 1}
          >
            Anterior
          </Button>
          <Chip
            className="mx-2"
            label={` Página ${filtros.page} de ${
              totalPaginas === 0 ? 1 : totalPaginas
            }`}
          />
          <Button
            onClick={() => handlePageChange(filtros.page + 1)}
            disabled={filtros.page === totalPaginas || totalPaginas === 0}
          >
            Próxima
          </Button>
        </Box>
      </DialogActions>
      <Loading loading={loading} />
    </Dialog>
  );
};

export default HistorioClienteDialog;
